import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup_portal';
import FindMultyStudentPopup from '@/pages/comp/basic/student/popup/find_multy';
import ViewDetailStudyListPopup from "@/pages/comp/plan/study/study/popup/view_detail_study_list";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';

const UseStuList = forwardRef((props: any, ref) => {
  const myProps = {
    "title_info": null,
    "infoArr": [],
    "list": (inOptObj: any) => { },
    ...props
  };
  const xColumnArr = getXcolumnJson();
  const [title_info, set_title_info] = useState(myProps.title_info);
  const [infoArr, setInfoArr] = useState(myProps.infoArr);
  const ListComponentRef = useRef<any>(null);
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    "s_title_seq": "",
    "s_stu_state": "now",
    "s_addon_study": "1",
    "s_addon_detail": "1",
    "is_need_count": "",
    "is_need_info_arr": "1",
    "is_no_limit": "1",
  });

  const setInitData = (inOptObj: any) => {
    if (inOptObj == undefined) {
      inOptObj = {};
    }
    let optObj = {
      "title_info": null,
      "infoArr": [],
      ...inOptObj
    };
    setInfoArr(optObj["infoArr"]);
    set_title_info(optObj["title_info"]);
    if (ListComponentRef.current) {
      ListComponentRef.current.setInfoArr(optObj["infoArr"]);
    }
    list({
      "s_title_seq": optObj["title_info"]["a_seq"],
    });
  };

  useEffect(() => {

  }, []);

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setInitData
  }));

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "find",//find,view_detail
    title: "팝업",
    width: "800px",
    height: "80%",
    stu_seq: "",
    study_title_seq:"",
    title_info: null,
    use_info: null,

    listOpt: {
      s_except_user_seq: "",
    },
    row_num: 0,
    key: "",
  });

  const list = (inData: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inData
    };
    setListOpt(change_list_opt);
    if (strFunc.is_empty(change_list_opt.s_title_seq)) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/study/study_use/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          //idx_num
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            response.data["data"]["info_arr"][i]["idx_num"] = i + 1;
          }
          setInfoArr(response.data["data"]["info_arr"]);
          ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const open_view_detail_study_popup = (inData:any) => {
    let opt_obj={
      stu_seq:"",
      study_title_seq:"",
      ...inData
    };
    let pop_title = "상세보기";
    if(strFunc.is_empty(opt_obj.stu_seq)){
      alert("학생키 없음.");
      return false;
    }
    if(strFunc.is_empty(opt_obj.study_title_seq)){
      alert("교재키 없음.");
      return false;
    }

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      "sort": "view_detail",
      "stu_seq": opt_obj.stu_seq,
      "study_title_seq": opt_obj.study_title_seq,
    });
  };

  const openInvitePopup = () => {
    let pop_title = "학생초대";
    let s_except_user_seq: any = [];
    for (let i = 0; i < infoArr.length; i++) {
      s_except_user_seq.push(infoArr[i].a_stu_seq);
    }

    setPopupData({
      ...popupData,
      ...{
        "isOpen": true,
        "title": pop_title,
        "sort": "find",
        listOpt: {
          s_except_user_seq: s_except_user_seq,
        },
      }
    });
  };

  const inviteStuUsers = (user_arr: any) => {
    if (user_arr.length == 0) {
      return false;
    }
    if (!confirm(user_arr.length + "명의 학생을 초대하시겠습니까?")) {
      return false;
    }
    if (title_info == null) {
      alert("교재 데이터가 없습니다.");
      return false;
    }
    if (strFunc.is_empty(title_info["a_seq"])) {
      alert("교재 키가 없습니다.");
      return false;
    }
    let user_seq_arr = [];
    for (let i = 0; i < user_arr.length; i++) {
      user_seq_arr.push(user_arr[i].a_seq);
    }
    let add_form_json = {
      study_title_seq: title_info.a_seq,
      user_seq_arr: user_seq_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/study/study_use/add_by_user', add_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
          myProps.list({ select_cat_seq: title_info.a_seq });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_write_stu_use = (inData: any) => {
    let opt_obj = {
      update_data_arr: [],
      ...inData
    };
    let update_data_arr = opt_obj.update_data_arr;

    let del_form_data = {
      "data_arr": update_data_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/study/study_use/write', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          // list({});
          // myProps.list({ select_cat_seq: title_info.a_seq });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const goDelete = (e: any) => {
    let selected_row = ListComponentRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let del_form_data = {
      "data_arr": selected_row
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/study/study_use/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          myProps.list({ select_cat_seq: title_info.a_seq });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const goDeleteUse = () => {
    let selected_row = ListComponentRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("선택 초기화 하시겠습니까?")) {
      return false;
    }
  };

  const on_change_row_input = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      row_num: 0,
      ...inData
    };
    let value = opt_obj.value;
    let name = opt_obj.name;
    let row_num = opt_obj.row_num;

    if(name=="a_now_page"){
      value = parseInt(strFunc.uncomma(value));
    }

    let change_info_arr = [...infoArr];
    if (change_info_arr[row_num]) {
      change_info_arr[row_num][name] = value;
    }
    setInfoArr(change_info_arr);
    ListComponentRef.current.setInfoArr(change_info_arr);

    if(name=="a_now_page"&&change_info_arr[row_num]){
      go_write_stu_use({
        update_data_arr:[change_info_arr[row_num]],
      });
    }
  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val
    }
    */
    let val_str = params.value;

    if (params.key == "row_view_per") {
      let tmp_detail_arr: any = [];
      if (params.rowData.detail_arr) {
        tmp_detail_arr = params.rowData.detail_arr;
      }
      let tmp_study_arr: any = [];
      if (params.rowData.study_arr) {
        tmp_study_arr = params.rowData.study_arr;
      }
      let sum_score: any = 0;
      for (let i = 0; i < tmp_detail_arr.length; i++) {
        let row_d_score = parseFloat(strFunc.uncomma(tmp_detail_arr[i]["a_text_score"]));
        if (row_d_score > 100) { row_d_score = 100; }
        if (tmp_detail_arr[i]["a_is_success"]) {
          row_d_score = 100;
        }
        sum_score += row_d_score;
      }
      if (sum_score > 0 && tmp_study_arr.length > 0) {
        sum_score = parseFloat("" + (sum_score / tmp_study_arr.length));
        sum_score = sum_score.toFixed(2);
      }

      let per_class_name = "";
      if (sum_score > 0) {
        per_class_name = "ready_color";
      }
      if (sum_score >= 100) {
        per_class_name = "success_color";
      }
      val_str = (
        <div className={per_class_name}>
          {sum_score + "%"}
        </div>
      );
    } else if (params.key == "row_view_a_now_page") {
      let open_pdf_btn:any="";
      if(title_info&&!strFunc.is_empty(title_info.a_book_pdf_url)){
        open_pdf_btn=(
          <button className="btn btn-dark ml-1" 
            onClick={() => {
              let pdf_v_url=process.env.REACT_APP_API_URL+"/home/util/pdf_viewr";
              pdf_v_url+="?pdf_url="+title_info.a_book_pdf_url+"&page="+params.rowData["a_now_page"];
              window.open(pdf_v_url);
            }} >열기</button>
        );
      }
      val_str = (
        <div>
          <input type="number" value={params.rowData["a_now_page"]}
            style={{ width: "60px", textAlign: "center" }}
            onChange={(e: any) => {
              on_change_row_input({ "name": "a_now_page", "value": e.target.value, "row_num": params.idx });
            }}
            onClick={(e:any)=>{
              e.target.select();
            }}
            />
            {open_pdf_btn}
        </div>
      );
    }else if(params.key=="row_view_detail_btn"){
      val_str=(
        <div>
          <button className="btn btn-dark"
            onClick={()=>{
              open_view_detail_study_popup({
                stu_seq:params.rowData.a_stu_seq,
                study_title_seq:params.rowData.a_study_title_seq,
              });
            }}
            >상세</button>
        </div>
      );
    }

    return val_str;
  }

  return (
    <div>
      <h4 className="mt-4" style={{ color: "#00f" }}>사용이력</h4>
      <div className="search-box py-0 mb-1">
        <button className="btn btn-dark" onClick={() => { list({ "now_page": "1" }); }}>검색</button>
        <button className="btn btn-dark" onClick={() => { openInvitePopup(); }}>초대</button>
        {/* <button className="btn btn-dark" onClick={goDeleteUse}>진행도초기화</button> */}
        <button className="btn btn-dark" onClick={goDelete}>삭제</button>
      </div>
      <ListComponent
        ref={ListComponentRef}
        infoArr={infoArr}
        xColumnArr={xColumnArr}
        gridOpt={
          {
            is_add_idx_num: true,
            is_add_checkbox: true,
            width: "100%",
            max_width: 1000,
            td_align: "center",//center,right
            table_align: "left",//center,right
            onGridReady: () => { },
            rowOnClick: (rowData: any, idx: number, e: any) => {

            },
            customCellRenderer: customCellRenderer
          }
        }
      ></ListComponent>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "find" &&
            <FindMultyStudentPopup
              listOpt={popupData.listOpt}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
              callBackData={(data: any) => {
                //data = { info_arr:[],row_num:0,key:"" };
                inviteStuUsers(data.info_arr);
              }}
            ></FindMultyStudentPopup>
          }
          {popupData.sort==="view_detail"&&
            <ViewDetailStudyListPopup
              stu_seq={popupData.stu_seq}
              study_title_seq={popupData.study_title_seq}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewDetailStudyListPopup>
          }
        </LayerPopup>
      }
    </div>
  );
});

export default UseStuList;
